import { Theme, darken } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

import imgLD1 from "assets/images/pngs/ld1.png";
import imgLD2 from "assets/images/pngs/ld2.png";
import imgLD3 from "assets/images/pngs/ld3.png";
import imgLD4 from "assets/images/pngs/ld4.png";
import imgLD5 from "assets/images/pngs/ld5.png";
import imgLD6 from "assets/images/pngs/ld6.png";
import imgLD7 from "assets/images/pngs/ld7.png";
import imgLD8 from "assets/images/pngs/ld8.png";
import imgLD10 from "assets/images/pngs/ld10.png";
import imgLD11 from "assets/images/pngs/ld11.png";
import imgLD12 from "assets/images/pngs/ld12.png";
import imgLD13 from "assets/images/pngs/ld13.png";

interface IProjectionBodyStylesProps {
    canSeeChart: boolean;
}

export default makeStyles((theme: Theme) =>
    createStyles({
        headerContainer: {
            width: "65%",
            alignItems: "center",
            [theme.breakpoints.down("wd")]: {
                width: "100%",
            },
        },
        navBox: {
            maxWidth: 600,
            height: 60,
            alignItems: "center",
            paddingLeft: theme.spacing(2),
            [theme.breakpoints.down("lg")]: {
                height: 50,
            },
        },
        navControls: {
            display: "flex",
            flex: "0 0 24px",
            justifyContent: "center",
            color: theme.palette.others.darkestColor,
            "& > button": {
                padding: 0,
            },
        },
        navBtnLeft: {
            justifyContent: "flex-start",
        },
        navBtnRight: {
            justifyContent: "flex-end",
        },
        navControlIcon: {
            fontSize: 24,
            color: theme.palette.others.darkestColor,
            [theme.breakpoints.down("lg")]: {
                fontSize: 24,
            },
        },
        navReportTitleBox: {
            flex: "0 0 60%",
            color: theme.palette.others.darkestColor,
            textAlign: "center",
        },
        navReportTitle: {
            fontSize: 20,
            fontWeight: 700,
            [theme.breakpoints.down("lg")]: {
                fontSize: 18,
            },
        },
        paceDefinitionWrapper: {
            display: "flex",
            flex: 2,
            justifyContent: "flex-end",
        },

        // Secondary Panel
        secondaryPanel: {
            display: "none",
            [theme.breakpoints.down("wd")]: {
                display: "block",
                paddingRight: theme.spacing(1),
            },
        },
        btnToInsights: {
            background: theme.palette.others.fauxWater,
            "&:hover": {
                background: darken(theme.palette.others.fauxWater, 0.08),
            },
            [theme.breakpoints.down("lg")]: {
                padding: theme.spacing(0.4, 1),
                fontSize: "1.3rem",
            },
            "& .MuiButton-startIcon": {
                "& .MuiSvgIcon-root": {
                    fontSize: "2.8rem",
                    marginRight: 10,
                    [theme.breakpoints.down("lg")]: {
                        fontSize: "2rem",
                        marginRight: 0,
                    },
                },
            },
        },
        // Projection Body Content
        projectionBodyWrapper: {
            height: "100%",
        },
        proGraphMsgWrapper: {
            position: "relative",
            height: "100%",
            width: "100%",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
            border: "1px solid #EAEAEA",
            borderRadius: "11px",
            "& > *": {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
            },
            "&[data-id='LD1']": {
                backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeChart ? "none" : `url(${imgLD1})`),
            },
            "&[data-id='LD2']": {
                backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeChart ? "none" : `url(${imgLD2})`),
            },
            "&[data-id='LD3']": {
                backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeChart ? "none" : `url(${imgLD3})`),
            },
            "&[data-id='LD4']": {
                backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeChart ? "none" : `url(${imgLD4})`),
            },
            "&[data-id='LD5']": {
                backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeChart ? "none" : `url(${imgLD5})`),
            },
            "&[data-id='LD6']": {
                backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeChart ? "none" : `url(${imgLD6})`),
            },
            "&[data-id='LD7']": {
                backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeChart ? "none" : `url(${imgLD7})`),
            },
            "&[data-id='LD8']": {
                backgroundImage: (props: IProjectionBodyStylesProps) => (props.canSeeChart ? "none" : `url(${imgLD8})`),
            },
            "&[data-id='LD10']": {
                backgroundImage: (props: IProjectionBodyStylesProps) =>
                    props.canSeeChart ? "none" : `url(${imgLD10})`,
            },
            "&[data-id='LD11']": {
                backgroundImage: (props: IProjectionBodyStylesProps) =>
                    props.canSeeChart ? "none" : `url(${imgLD11})`,
            },
            "&[data-id='LD12']": {
                backgroundImage: (props: IProjectionBodyStylesProps) =>
                    props.canSeeChart ? "none" : `url(${imgLD12})`,
            },
            "&[data-id='LD13']": {
                backgroundImage: (props: IProjectionBodyStylesProps) =>
                    props.canSeeChart ? "none" : `url(${imgLD13})`,
            },
        },
        projectionBodyLeftSide: {
            padding: theme.spacing(0, 2, 5),
            height: "calc(100vh - 175px)",
            transition: "all .8s",
            width: "65%",
            position: "relative",
            [theme.breakpoints.down("wd")]: {
                width: "100%",
            },
            [theme.breakpoints.down("lg")]: {
                height: "calc(100vh - 70px)",
            },
        },
        chatVisible: {
            height: "calc(100vh - 252px)",
        },
        projectionBodyRightSide: {
            padding: theme.spacing(3, 4, 0),
            marginTop: -60,
            marginLeft: "auto",
            transition: "padding .8s",
            borderLeft: `4px solid ${theme.palette.others.fauxWater}`,
            width: "35%",
            [theme.breakpoints.down("wd")]: {
                width: "100%",
                height: "auto",
                borderLeft: "none",
                margin: 0,
                padding: theme.spacing(4, 4, 4, 6),
            },
            // This is the textContainer
            "& > div:nth-of-type(2)": {
                height: "calc(100vh - 480px)",
                overflowY: "auto",
                [theme.breakpoints.down("wd")]: {
                    height: "auto",
                },
            },
        },
    })
);
